import React from 'react';
import { Outlet } from 'react-router-dom';
import { useShallowEqualSelector } from 'src/customHooks/useShallowEqualSelector';
import { userInitLoadedSelector } from 'src/redux/features/userInit/selectors';
import { currentUsersLoadedSelector } from 'src/redux/features/users/currentUsers/selectors';
import { State } from 'src/redux/reducer';
import UserService from 'src/services/UserService';
import CenterLoader from '../CenterLoader';

export interface PrivateRouterProps {}

const PrivateRoute: React.FC<PrivateRouterProps> = () => {
  const [isLoadedInit, isLoadedCurrent] = useShallowEqualSelector(
    (state: State) => [
      userInitLoadedSelector(state),
      currentUsersLoadedSelector(state),
    ],
  );

  return UserService.isLoggedIn() && isLoadedInit && isLoadedCurrent ? (
    <Outlet />
  ) : (
    <CenterLoader />
  );
};

export default PrivateRoute;
